module.exports = __webpack_public_path__ + "fdf491ce5ff5b2da02708cd0e9864719.woff";